import React from 'react';

import Grid from '@mui/material/Grid2';

import { DEMAND_APP_ID } from '../../../../store/demand';
import MembershipsTable from '../../../../components/Table/MembershipsTable';

export default function Memberships() {
  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='flex-start'
      spacing={1}
      sx={{ maxWidth: '100%', mt: 1 }}
    >
      <Grid
        size={{ xs: 12 }}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          maxWidth: '100vw',
          px: 1,
        }}
      >
        <MembershipsTable appId={DEMAND_APP_ID} />
      </Grid>
    </Grid>
  );
}
